import { render } from "./HomeIndex.vue?vue&type=template&id=41142e73&scoped=true&ts=true"
import script from "./HomeIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./HomeIndex.vue?vue&type=script&setup=true&lang=ts"

import "./HomeIndex.vue?vue&type=style&index=0&id=41142e73&lang=scss&scoped=true"

import exportComponent from "/Users/luoke/Desktop/新开发代码_git/h5-jalalive/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41142e73"],['__file',"src/components/home/HomeIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41142e73"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41142e73', __exports__)) {
    console.log('reload')
    api.reload('41142e73', __exports__)
  }
  
  module.hot.accept("./HomeIndex.vue?vue&type=template&id=41142e73&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('41142e73', render)
  })

}


export default __exports__